<template>
  <div
    :class="[
      this.getApplicationLevel() < parseInt(step) ? lockedStep : activeStep,
      defaultStep,
    ]"
  >
    <router-link :to="{ name: to }">
      <div
        class="w-full bg-purple-ap-100 p-3 text-white rounded step flex flex-col items-center justify-center"
      >
        <span
          class="block step-desc"
          v-if="this.getApplicationLevel() <= parseInt(step)"
          >Step <strong>{{ step }}</strong></span
        >
        <span class="block step-desc" v-else>Completed</span>
        <h3 class="step-title">
          <span>{{ title }}</span>
        </h3>
      </div>
      <img :src="require(`../../assets/img/${this.imageSrc}`)" />
    </router-link>
    <div
      v-if="this.getApplicationLevel() < parseInt(step)"
      class="lock rounded"
    >
      <i class="material-icons">lock</i>
    </div>
  </div>
</template>

<script>
import { getApplicationLevel } from "@/helpers.js";

export default {
  name: "ChiApplicationStep",
  props: ["step", "title", "imageSrc", "to"],
  methods: {
    getApplicationLevel() {
      return getApplicationLevel(this.$store.state.user);
    },
  },
  data() {
    return {
      activeStep: "step step-active rounded",
      lockedStep: "step step-locked rounded",
      defaultStep: "step relative mx-2 shadow-lg p-0",
    };
  },
};
</script>

<style scoped>
.step {
  min-height: 150px;
}

.step-desc {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 300;
  text-align: center;
  margin-bottom: 5px;
}

.step-desc strong {
  font-size: 1.5rem;
  vertical-align: middle;
}

.step-title {
  font-size: 1.3rem;
  line-height: 1.1em;
  text-transform: normal;
  font-weight: 600;
  text-align: center;
  margin-bottom: 5px;
}

.step {
  position: relative;
}

.step-locked {
  filter: grayscale(100%);
}

.lock {
  background-color: #00000099;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lock i:hover,
.lock:hover {
  cursor: pointer;
}

.lock i {
  color: #fff;
  font-size: 60px;
  cursor: none;
}

.lock p {
  font-size: 1.1rem;
  color: #fff;
  margin-top: 10px;
  padding: 0 20px;
  font-weight: 600;
}
</style>
